import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isSaveOrderShippingEnabled: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const Enableplaceordershippinghandling: HandlerType = props => {
    props.dispatch({
        type: "Pages/EnableplaceordershippinghandlingState",
        isSaveOrderShippingEnabled: props.parameter.isSaveOrderShippingEnabled,
    });
};

export const chain = [Enableplaceordershippinghandling];

const enablePlaceOrderShippingHandling = createHandlerChainRunner(chain, "EnableplaceordershippinghandlingHandler");
export default enablePlaceOrderShippingHandling;
